// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__3KIQB","actionColumn":"ReferralSources_actionColumn__34u3q","textButton":"ReferralSources_textButton__2Jd7L"};